import { fork } from "redux-saga/effects";

import * as auth from "../app/modules/Auth/saga/authSaga";
import * as customerMessage from "../app/modules/CustomerMessage/saga/sagas";

// function* saga() {
//     yield fork(auth.watchLoadingCaptcha);
//     yield takeLatest(actionTypes.Login, auth.loginSaga);
//     yield fork(auth.watchLoginError);
//     yield takeLatest(actionTypes.Register, auth.registerSaga);
//     yield takeLatest(actionTypes.UserRequested, auth.userRequested);
//   }

// 監聽所有saga讓其在背景執行
function* saga() {
  yield fork(auth.watchLoadingCaptcha);
  // yield fork(auth.watchLoginSaga);
  yield fork(customerMessage.watchRequestMessageDetail);
  yield fork(auth.watchLoginError);
  yield fork(auth.watchRegisterSaga);
  yield fork(auth.watchUserRequested);
}


export default saga;